import React from 'react'
import Particles from 'react-particles-js'

const ParticlesBackground = () => (
  <Particles className="hero-particles" params={{
    particles: {
      color: {value: "#9BDDF5"},
      shape: {
        type: 'circle',
        stroke: {
          width: 3,
          color: "#9BDDF5"
        },
      },
      opacity: {
        value: 0.5,
      },
      line_linked: {
        enable: true,
        color: "#E096C1",
        opacity: 0.3
      },
      move: {
        speed: 1,
        random: true
      },
      interactivity: {
        detect_on: "window",
        events: {
          onhover: {
            enable: true,
            mode: "repulse"
          },
        }
      }
    }
  }}/>
)

export default ParticlesBackground
